module.exports = {
  'united-kingdom': 'GB',
  germany: 'DE',
  'united-states': 'US',
  france: 'FR',
  russia: 'RU',
  mauritius: 'MU',
  poland: 'PL',
  netherlands: 'NL',
  india: 'IN',
  israel: 'IL',
  kazakhstan: 'KZ',
  mexico: 'MX',
  indonesia: 'ID',
  portugal: 'PT',
  sweden: 'SE',
  canada: 'CA',
  'hong-kong': 'HK',
  china: 'CN',
  philippines: 'PH',
  morocco: 'MA',
  ukraine: 'UA',
  ireland: 'IE',
  brazil: 'BR',
  romania: 'RO',
  nigeria: 'NG',
  spain: 'ES',
  thailand: 'TH',
  'czech-republic': 'CZ',
  italy: 'IT',
  japan: 'JP',
  taiwan: 'TW',
  austria: 'AT',
  singapore: 'SG',
  'south-korea': 'KR',
  finland: 'FI',
  australia: 'AU'
}
